export default __webpack_public_path__ + "static/media/tutorial-02.7d9201ca.jpg";